import { Search } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import useActivityString from "../../translations/useActivityString";
import BooleanFilters from "./BooleanFilters";

// NOTE: CapacityFilter in the Categories is very similar to this, consolidate it in the future.
export default function ClassSizeFilter({
  onChange,
  searchFilters,
}: {
  onChange: (value: Search.CapacityFilterType) => void;
  searchFilters: SearchFiltersType;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\desktop\\ClassSizeFilter",
  );
  const { classSizeOptions } = useActivityString();
  const sizeOptions = classSizeOptions.filter(option => option.value !== "Any");

  const selectedClassSizes =
    Search.getClassSizesFromCapacityFilter(searchFilters);

  const handleFilterChange = (selectedValue: Search.ClassSize[]) => {
    const filterValue = Search.getCapacityFiltersFromClassSize(selectedValue);
    onChange(filterValue);
  };

  return (
    <BooleanFilters
      label={t("Size")}
      filters={sizeOptions}
      enabledFilters={selectedClassSizes}
      setEnabledFilters={handleFilterChange}
      onChange={handleFilterChange}
    />
  );
}
